import React from 'react'

export default function TechnographicsUse() {
  return (
    <div className='Techno-img mt-3'>
      <div className="section_main_title">
                <h3>Technographics for <span>Business Growth</span> 
                </h3>
      </div>
      <div className="em_bar">
                <div className="em_bar_bg"></div>
              </div>
        <img src='assets/images/Technographics.webp' className='img-fluid' alt="Technographics for business growth"/>
     
    </div>
  )
}
